import { MdArrowForwardIos } from 'react-icons/md'
import { Box, Flex, type FlexProps } from '@chakra-ui/react'
import { GrandLink, GrandText } from 'ui/common'
import { type UITopNavMenuItem } from '../../types'

type NavListItemProps = {
  item: UITopNavMenuItem
  isLink?: boolean
  reverseLinkStyle?: boolean
} & FlexProps

export const MobileMenuListItem = ({
  item,
  isLink,
  reverseLinkStyle,
  ...props
}: NavListItemProps) => {
  const commonStyles = {
    py: 4,
    px: 6,
    fontSize: 'md'
  }

  if (isLink || !item.options?.length) {
    return (
      <Flex {...props}>
        <GrandLink
          {...commonStyles}
          _hover={{
            textDecoration: reverseLinkStyle ? 'underline' : 'none'
          }}
          href={item.path}
          textDecoration={reverseLinkStyle ? 'none' : 'underline'}
          userSelect="none"
        >
          {item.text}
        </GrandLink>
      </Flex>
    )
  }

  return (
    <Box w="100%">
      <Flex
        {...commonStyles}
        _hover={{
          bg: 'background.surface'
        }}
        alignItems="center"
        cursor="pointer"
        justifyContent="space-between"
        userSelect="none"
        w="100%"
        {...props}
      >
        <GrandText>{item.text}</GrandText>

        <Box fontSize="md">
          <MdArrowForwardIos />
        </Box>
      </Flex>
    </Box>
  )
}
